import { Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export const AddressingLineInputLabel = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="row" gap={Spacing.S4}>
      <Text colorVariant="secondary">{t('external_invoices.send_as_e_invoice.modal.field.addressing_line.label')}</Text>
      <Tooltip
        label={t('external_invoices.send_as_e_invoice.modal.field.addressing_line.label_tooltip')}
        placement="top"
      >
        <Icon icon="circleQuestionMark" size="xs" />
      </Tooltip>
    </Flex>
  )
}
